(function () {
  if (window.__senifoneBFGiftInitialized) return;
  window.__senifoneBFGiftInitialized = true;

  var config = (window.theme && window.theme.blackFridayGift) || {};
  var promoEnabled = !!config.enabled && config.windowActive !== false;
  var discountOnlyMode = !!config.discountOnly;

  function noopPromise() {
    return Promise.resolve();
  }

  function extractNumericId(value) {
    if (!value && value !== 0) return '';
    var matches = String(value).match(/\d+/g);
    return matches ? matches.join('') : '';
  }

  if (!promoEnabled || discountOnlyMode) {
    window.SeniGiftPromo = window.SeniGiftPromo || {};
    window.SeniGiftPromo.normalizeCart = noopPromise;
    return;
  }

  var giftVariantIdValue = extractNumericId(config.giftVariantIdNumeric || config.giftVariantId);
  var giftVariantId = parseInt(giftVariantIdValue, 10);
  if (!giftVariantId || Number.isNaN(giftVariantId)) {
    console.warn('[Senifone Promo] Missing gift variant id.');
    window.SeniGiftPromo = window.SeniGiftPromo || {};
    window.SeniGiftPromo.normalizeCart = noopPromise;
    return;
  }

  var s1Handle = config.s1Handle || '';
  var s1VariantInput = config.s1VariantInput || '';
  var s1Variants = s1VariantInput
    .split(/[\s,]+/)
    .map(function (id) {
      var numeric = extractNumericId(id);
      return numeric ? parseInt(numeric, 10) : NaN;
    })
    .filter(function (id) {
      return !Number.isNaN(id);
    });

  var state = {
    running: null,
    rerun: false,
    oosWarned: false,
  };

  function isS1Item(item) {
    if (!item) return false;
    if (s1Variants.length && s1Variants.indexOf(item.variant_id) !== -1) {
      return true;
    }
    if (s1Handle && item.product_handle === s1Handle) {
      return true;
    }
    return false;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to update cart line');
      }
    });
  }

  function runNormalize(source) {
    return fetchCart()
      .then(function (cart) {
        var s1Quantity = 0;
        var giftLine = null;

        cart.items.forEach(function (item) {
          if (isS1Item(item)) {
            s1Quantity += item.quantity;
          }
          if (item.variant_id === giftVariantId) {
            giftLine = item;
          }
        });

        if (s1Quantity <= 0) {
          if (giftLine) {
            return changeLine(giftLine.key, 0);
          }
          return null;
        }

        if (!config.giftAvailable) {
          if (!state.oosWarned && config.oosMessage) {
            console.warn('[Senifone Promo] ' + config.oosMessage);
            state.oosWarned = true;
          }
          if (giftLine) {
            return changeLine(giftLine.key, 0);
          }
          return null;
        }

        if (!giftLine) {
          return null;
        }

        if (giftLine.quantity !== 1) {
          return changeLine(giftLine.key, 1);
        }

        return null;
      })
      .catch(function (error) {
        console.warn('[Senifone Promo] normalize failed (' + source + '):', error);
      });
  }

  function queueNormalize(source) {
    if (!promoEnabled) {
      return noopPromise();
    }

    if (!state.running) {
      state.running = runNormalize(source).then(function () {
        state.running = null;
        if (state.rerun) {
          state.rerun = false;
          queueNormalize('rerun');
        }
      });
      return state.running;
    }

    state.rerun = true;
    return state.running;
  }

  document.addEventListener('theme:cartchanged', function () {
    queueNormalize('cartchanged');
  });

  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      queueNormalize('DOMContentLoaded');
    });
  }

  var previousFetch = window.fetch;
  window.fetch = function (resource, init) {
    var response = previousFetch.apply(this, arguments);
    var url = '';

    if (typeof resource === 'string') {
      url = resource;
    } else if (resource && typeof resource.url === 'string') {
      url = resource.url;
    }

    if (url.indexOf('/cart/') !== -1 && response && typeof response.then === 'function') {
      var handleCompletion = function () {
        queueNormalize('fetch');
      };
      response.then(handleCompletion, handleCompletion);
    }

    return response;
  };

  window.SeniGiftPromo = window.SeniGiftPromo || {};
  window.SeniGiftPromo.normalizeCart = queueNormalize;
})();
